import {useState} from 'react'
import {TagOption} from '../components/TagModal'
import {useI18n} from '../../../../Utils/_helpers/useI18n'
import {toast} from 'react-toastify'
import {useAddTagtoRowContactMutation} from '../../../../../services/cellcast.v2'

interface UseContactTagsProps {
  onSuccess?: () => void
  fetchContacts: (options?: { forceRefresh?: boolean }) => void
}

export const useContactTags = ({onSuccess, fetchContacts}: UseContactTagsProps) => {
  const [isLoading, setIsLoading] = useState(false)
  const {t} = useI18n()
  const [addTagToContacts] = useAddTagtoRowContactMutation()
  
  const handleAddTags = async (contactIds: string[], tags: TagOption[]) => {
    try {
      setIsLoading(true)

      // Transform tags to the format expected by the API
      const tagIds = tags.map((tag) => tag.value)

      // Call the mutation to add tags to contacts
      await addTagToContacts({
        contactIds,
        tagIds,
      }).unwrap()

      // Show success message
      toast.success(t('RAW_CONTACT_COLLECTION.TAG_MODAL.SUCCESS_MESSAGE'))
      fetchContacts({ forceRefresh: true })
      
      // Call onSuccess callback if provided
      if (onSuccess) {
        onSuccess()
      }
    } catch (error) {
      // Show error message
      toast.error(t('RAW_CONTACT_COLLECTION.TAG_MODAL.ERROR_MESSAGE'))
      console.error('Error adding tags to contacts:', error)
    } finally {
      setIsLoading(false)
    }
  }

  return {
    addTags: handleAddTags,
    isLoading,
  }
}

// Export the hook
export default useContactTags
